import { render, staticRenderFns } from "./skjl.vue?vue&type=template&id=529748e2&"
import script from "./skjl.vue?vue&type=script&lang=js&"
export * from "./skjl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports